// extracted by mini-css-extract-plugin
export default {"header":"ParentCategory_header__cGp8a","rule":"ParentCategory_rule__H6a+T"};